var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"burst-reply-action",on:{"click":_vm.loginRegister}},[_c('div',{staticClass:"action-description"},[_vm._v("Sign up to continue watching!")])])}
var staticRenderFns = []

export { render, staticRenderFns }